export const isValidToken = (token: string): boolean => {
  try {
    const decodedJwt = JSON.parse(atob(token.split('.')[1]));
    return decodedJwt.exp * 1000 > Date.now();
  } catch {
    throw new Error('Invalid token');
  }
};
